/* globals Clipboard */
angular
  .module('mandaeApp')
  .directive('copyToClipboard', function () {
    'use strict';
    return {
      restrict: 'A',
      link: function (scope, element) {
        var tooltipOpts = {
          title: 'Copiado!',
          placement: 'bottom',
          trigger: 'manual',
        };
        var clipboard = new Clipboard(element[0], {
          text: function() {
            return element.parent().parent().find('input').val();
          },
        });
        element
          .tooltip(tooltipOpts)
          .on('click', function(){
            element.tooltip('show');
          })
          .on('mouseleave', function(){
            element.tooltip('hide');
          });
        scope.$on('$destroy', function(){
          clipboard.destroy();
          element.tooltip('destroy');
        });
      },
    };
  });
